// Copyright (c) Microsoft Corporation. All rights reserved.

import React, { Component, Fragment } from "react";

import WegoAuth from "./WegoAuth";
import WegoAuthUser from "./WegoAuthUser";
import WegoConfiguaration from "../WegoConfiguration";

type WegoAuthServiceProps = {
    wegoConfiguration: WegoConfiguaration;
    onLoggedIn: () => void;
    onNotLoggedIn: () => void;
}

type WegoAuthServiceState = {

}

/*
** This service is ONLY used to support development scenarios in a naked browser session.
** When running outside Teams, we can"t rely on their SSO.  So we need to support our own.
*/
export default class WegoBrowserAuthService extends Component<WegoAuthServiceProps, WegoAuthServiceState> {
    authProvider: WegoAuth

    constructor(props: WegoAuthServiceProps) {
        super(props);
        this.authProvider = new WegoAuth(false, props.wegoConfiguration);
    }

    async componentDidMount() {
        //await this.authProvider.msalObject!.handleRedirectPromise();
    }

    determineLoginStatus() {
        this.isAuthenticated() ? this.props.onLoggedIn() : this.props.onNotLoggedIn();
    }

    isAuthenticated(): boolean {
        return this.authProvider.msalObject!.getAllAccounts().length > 0 ? true : false;
    }

    login(): Promise<void> {
        console.log(this.authProvider.msalObject);
        return this.authProvider.msalObject!.loginRedirect({
            scopes: [this.authProvider.getScope()]
        });
    }

    getToken(): Promise<string> {
        return this.authProvider.getToken();
    }

    getUser(): Promise<WegoAuthUser> {
        return this.authProvider.getUser();
    }

    render() {
        return (
            <Fragment></Fragment>
        );
    }
}